var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZookeeper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline/zookeeper_nor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 541"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xE6\xA4\xAD\xE5\x9C\x86\xE5\xBD\xA2",
    d: "M11.8909 6.0727C12.8549 6.0727 13.6364 5.29123 13.6364 4.32724C13.6364 3.36325 12.8549 2.58179 11.8909 2.58179C10.9269 2.58179 10.1454 3.36325 10.1454 4.32724C10.1454 5.29123 10.9269 6.0727 11.8909 6.0727Z",
    stroke: "currentColor",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xE6\xA4\xAD\xE5\x9C\x86\xE5\xBD\xA2\xE5\xA4\x87\xE4\xBB\xBD",
    d: "M16.8364 4.32727C17.479 4.32727 18 3.8063 18 3.16364C18 2.52098 17.479 2 16.8364 2C16.1937 2 15.6727 2.52098 15.6727 3.16364C15.6727 3.8063 16.1937 4.32727 16.8364 4.32727Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xE8\xB7\xAF\xE5\xBE\x84",
    d: "M9.50549 18.2908V14.509C9.50549 14.027 9.27277 13.6363 9.27277 11.8908C9.27277 11.3737 9.27277 10.9858 9.27277 10.7272C9.27277 10.3393 9.27277 9.75751 9.27277 8.98175C9.27277 8.33909 9.6635 7.81812 10.1455 7.81812H13.6364C14.1184 7.81812 14.5091 8.33909 14.5091 8.98175C14.5091 9.75751 14.5091 10.3393 14.5091 10.7272C14.5091 10.9858 14.5091 11.3737 14.5091 11.8908C14.5091 13.6363 14.2764 14.027 14.2764 14.509V18.2908",
    stroke: "currentColor",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xE8\xB7\xAF\xE5\xBE\x84-10",
    d: "M14.2 8.19995L17.0454 10.1799C17.4548 10.5894 17.5009 11.2376 17.1535 11.7009L15.2655 14.2182",
    stroke: "currentColor",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xE8\xB7\xAF\xE5\xBE\x84-11",
    d: "M9.5 8.20007L7.75014 9.87811C7.35355 10.354 6.65363 10.4358 6.15803 10.0641L3.93939 8.4001",
    stroke: "currentColor",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xE8\xB7\xAF\xE5\xBE\x84-12",
    d: "M4.03638 2V13.6364",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xE7\x9F\xA9\xE5\xBD\xA2",
    d: "M4.61814 14.2181H3.4545C3.13317 14.2181 2.87268 14.4786 2.87268 14.8V16.8363C2.87268 17.1577 3.13317 17.4181 3.4545 17.4181H4.61814C4.93946 17.4181 5.19995 17.1577 5.19995 16.8363V14.8C5.19995 14.4786 4.93946 14.2181 4.61814 14.2181Z",
    stroke: "currentColor",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xE7\x9F\xA9\xE5\xBD\xA2\xE5\xA4\x87\xE4\xBB\xBD-3",
    d: "M5.97273 3.45459H2.1C2.04477 3.45459 2 3.49936 2 3.55459V4.51823C2 4.57345 2.04477 4.61823 2.1 4.61823H5.97273C6.02796 4.61823 6.07273 4.57345 6.07273 4.51823V3.55459C6.07273 3.49936 6.02796 3.45459 5.97273 3.45459Z",
    stroke: "currentColor",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xE7\x9F\xA9\xE5\xBD\xA2\xE5\xA4\x87\xE4\xBB\xBD-4",
    d: "M4.9 8H3.1C3.04477 8 3 8.04477 3 8.1V9.4C3 9.45523 3.04477 9.5 3.1 9.5H4.9C4.95523 9.5 5 9.45523 5 9.4V8.1C5 8.04477 4.95523 8 4.9 8Z",
    stroke: "currentColor",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xE8\xB7\xAF\xE5\xBE\x84-9",
    d: "M11.8909 18.2909V13.6364",
    stroke: "currentColor",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xE8\xB7\xAF\xE5\xBE\x84-13",
    d: "M8.69092 3H15.0909",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xE8\xB7\xAF\xE5\xBE\x84-13\xE5\xA4\x87\xE4\xBB\xBD",
    d: "M10.4363 1.58179H13.3454",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZookeeper);
export default __webpack_public_path__ + "static/media/zookeeper.9bc48d1baf2e832d0b5012c1cecc31ec.svg";
export { ForwardRef as ReactComponent };